import Addon from '../../classes/addon';
import Pages from '@pages';
import Slider from '../../classes/slider';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

function goToAddon(asset: Addon | Slider) {
  const { router } = store.getState();
  let newPage: () => JSX.Element = Pages.DETAIL_ADDON;
  if (
    ((asset as Addon).checkAddon && (asset as Addon).checkAddon()) ||
    router.route.Page === Pages.INITIAL
  ) {
    newPage = Pages.ADDON;
  } else if (Addon.checkAddon((asset as Slider).plan || '')) {
    newPage = Pages.ADDON;
  }
  store.dispatch(
    pushRoute({
      route: {
        Page: newPage,
      },
      params: {
        current: {
          asset,
          previousFocus: false,
        },
        push: true,
      },
    })
  );
}

export default goToAddon;
